// extracted by mini-css-extract-plugin
export default {"store":"Store_store__QG+D+"};